import styled from 'styled-components';

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: ${({ $color }) => `${$color}15`};
  border: 1px solid ${({ $color }) => `${$color}50`};
  border-radius: 6px;
  color: ${({ $color }) => $color};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $color }) => `${$color}25`};
    border-color: ${({ $color }) => `${$color}70`};
  }
`;

export const DropdownIcon = styled.span`
  font-size: 8px;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 140px;
  overflow: hidden;
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 10px 16px;
  background: ${({ $isActive, $color }) => ($isActive ? `${$color}10` : 'white')};
  border: none;
  border-left: 3px solid ${({ $color }) => $color};
  color: #1d3557;
  font-size: 13px;
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '400')};
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ $color }) => `${$color}15`};
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;
